module.exports = __webpack_public_path__ + "static/img/3.54b2a529.jpg";